<div class="min-w-full">
    <nav class="bottom-0 w-full h-full py-2 overflow-hidden text-xs bg-white shadow">
        <ul class="flex items-center justify-around text-xs font-medium text-center">
            <li>
                <a [routerLink]="['/home/dashboard']" routerLinkActive="active" #rlaDashboard="routerLinkActive"
                    [ngClass]="rlaDashboard.isActive ? 'text-green-900 && font-extrabold' : 'text-gray-400'"
                    class="flex items-center px-2 space-x-2 text-gray-400 rounded-lg">
                    <svg class="w-10 h-10 mx-auto fill-current" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z">
                        </path>
                    </svg>
                </a>
                <p class="text-xs font-medium text-centertext-gray-400">Dashboard</p>
            </li>
            <li class="relative">
                <a [routerLink]="['/home/notifications']" routerLinkActive="active" #rlaNotifications="routerLinkActive"
                    [ngClass]="rlaNotifications.isActive ? 'text-green-900 && font-extrabold' : 'text-gray-400'"
                    class="flex items-center px-2 space-x-2 text-gray-400 rounded-lg">
                    <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9">
                        </path>
                    </svg>
                </a>
                <div *ngIf="notifications.length>0" class="absolute bg-yellow-500 p-1 rounded-full left-10 bottom-10 ">{{notifications.length}}</div>
                <p class="text-xs font-medium text-centertext-gray-400">Notifications</p>
            </li>

            <li>
                <a [routerLink]="['/home/transactions']" routerLinkActive="active" #rlaTransactions="routerLinkActive"
                    [ngClass]="rlaTransactions.isActive ? 'text-green-900 && font-extrabold' : 'text-gray-400'"
                    class="flex items-center px-2 space-x-2 text-gray-400 rounded-lg ">
                    <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2">
                    </path>
                </svg>
                </a>
                <p class="text-xs font-medium text-centertext-gray-400">Transactions</p>
            </li>
            <li>
                <a [routerLink]="['/home/settings']" routerLinkActive="active" #rlaSettings="routerLinkActive"
                    [ngClass]="rlaSettings.isActive ? 'text-green-900 && font-extrabold' : 'text-gray-400'"
                    class="flex items-center px-2 space-x-2 text-gray-400 rounded-lg ">
                    <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
                        </path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z">
                        </path>
                    </svg>
                </a>
                <p class="text-xs font-medium text-centertext-gray-400">Settings</p>
            </li>
        </ul>
    </nav>
</div>
